import script from "./CardHrWorkforce.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHrWorkforce.vue?vue&type=script&setup=true&lang=js"

import "./CardHrWorkforce.vue?vue&type=style&index=0&id=49cc8b8e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cc8b8e"]])

export default __exports__